const SectionCont2 = () => {
	return (
		<section className="sub-content cont2">
			<div className="sub-inner">
				<ul className="brand-list">
					<li>
						<p>
							사업의 출발부터 도약까지
							<br />
							스텔라는 기업의
							<br />
							비즈니스 여정을 함께하는
							<br />
							<span className="font-bold">올인원 비즈니스 플랫폼</span>입니다.
						</p>
					</li>
					<li className="ico1">
						<div className="desc-group">
							<p className="title">전문가가 직접 만든 기업 솔루션</p>
							<p className="desc">
								삼일회계법인의 전문성과 핑거의 IT 기술력이 결합 된 스텔라는 <br />
								AI 기반 자동화와 데이터 허브를 통해 업무 효율을 혁신적으로 개선합니다.
							</p>
						</div>
					</li>
					<li className="ico2">
						<div className="desc-group">
							<p className="title">시대가 요구하는 자동화 & AI</p>
							<p className="desc">
								자동화 된 데이터 수집과 AI 기반 분석으로 <br />
								단순 반복 업무를 줄이고 전략적 의사결정에 더 많은 시간을 <br />
								투자할 수 있도록 지원합니다.
							</p>
						</div>
					</li>
					<li className="ico3">
						<div className="desc-group">
							<p className="title">유연하고 확장 가능한 ERP</p>
							<p className="desc">
								직관적인 UI와 모듈형 설계로 기업의 규모와 필요에 따라 <br />
								유연하게 확장할 수 있으며, 통합된 데이터 관리 시스템으로 <br />
								실시간 비즈니스 인사이트를 제공합니다.
							</p>
						</div>
					</li>
				</ul>
			</div>
			<div className="text-box">
				<p>
					스텔라는 기업이 <span>더 나은 의사결정</span>을 내리고 핵심 업무에 집중할 수 있도록 지원합니다. <br />
					지금 시작하는 작은 기업부터 미래를 준비하는 성장 기업까지,
					<span>스텔라는 든든한 성공 파트너로 함께합니다.</span>
				</p>
			</div>
		</section>
	);
};

export default SectionCont2;
